import Collapsable from "components/Collapsable";
import Content from "components/Content";
import Label from "components/Label";
import Link from "components/Link";
import text from "constants/text";
import React, { FC, useState } from "react";

import styles from "./styles.module.scss";

const FAQ: FC = () => {
  const [selectedQuestion, setSelectedQuestion] = useState<null | string>(null);

  const { categories, redirects, title, description } = text.faq;

  return (
    <Content contentClassName={styles.container}>
      <Label className={styles.title} variant="h-centered" color="primary">
        {title}
      </Label>
      <Label className={styles.subtitle} variant="s-centered" color="primary">
        {description}
      </Label>
      <div className={styles.redirects}>
        {redirects.map(({ reads, to }) => (
          <Link className={styles.link} color="primary" label={reads} to={to} />
        ))}
      </div>
      {categories.map(({ title: category, questions, id }) => (
        <div id={id} className={styles.section}>
          <Label className={styles.sectionTitle} variant="h" color="primary">
            {category}
          </Label>
          <div className={styles.sectionFAQs}>
            {questions.map(({ question, answer }) => (
              <Collapsable
                withIcon
                open={selectedQuestion === question}
                onSelect={(selectedID: string) => {
                  if (selectedID === selectedQuestion)
                    setSelectedQuestion(null);
                  else setSelectedQuestion(selectedID);
                }}
                id={question}
                className={styles.collapsable}
                header={
                  <div className={styles.question}>
                    <Label
                      variant="s"
                      color="primary"
                      className={styles.qLabel}
                    >
                      {question}
                    </Label>
                  </div>
                }
              >
                <Label className={styles.answer} variant="s" color="primary">
                  {answer}
                </Label>
              </Collapsable>
            ))}
          </div>
        </div>
      ))}
    </Content>
  );
};
export default FAQ;
